/**
 * 🚀 타이머 보상 시스템 활성화 유틸리티
 * 
 * 사용 방법:
 * 1. 브라우저 콘솔에서 실행:
 *    window.enableTimerReward()
 * 
 * 2. 또는 직접 호출:
 *    import { enableTimerReward } from './utils/enableTimerReward';
 *    enableTimerReward();
 * 
 * 활성화 후:
 * - StudyCafeV4.js의 타이머 보상 관련 주석을 해제해야 합니다
 * - import 문 (11-13줄)
 * - 타이머 보상 시스템 코드 (약 36-68줄)
 * - 모달 렌더링 부분 (약 199-207줄)
 */

export const enableTimerReward = () => {
  // localStorage에 활성화 플래그 설정
  localStorage.setItem('ENABLE_TIMER_REWARD', 'true');
  
  console.log('✅ 타이머 보상 시스템 활성화 플래그가 설정되었습니다.');
  console.log('📝 다음 단계:');
  console.log('1. StudyCafeV4.js 파일을 열어주세요');
  console.log('2. import 문 (11-13줄)의 주석을 해제하세요');
  console.log('3. 타이머 보상 시스템 코드 (약 36-68줄)의 주석을 해제하세요');
  console.log('4. 모달 렌더링 부분 (약 199-207줄)의 주석을 해제하세요');
  console.log('5. 페이지를 새로고침하세요');
  
  return true;
};

export const disableTimerReward = () => {
  localStorage.removeItem('ENABLE_TIMER_REWARD');
  console.log('❌ 타이머 보상 시스템 활성화 플래그가 제거되었습니다.');
  console.log('📝 StudyCafeV4.js의 타이머 보상 관련 코드를 다시 주석처리하세요');
  
  return true;
};

// 브라우저 콘솔에서 사용할 수 있도록 window 객체에 등록
if (typeof window !== 'undefined') {
  window.enableTimerReward = enableTimerReward;
  window.disableTimerReward = disableTimerReward;
  
  console.log('🚀 타이머 보상 시스템 활성화 유틸리티가 로드되었습니다.');
  console.log('💡 사용 방법: window.enableTimerReward() 또는 window.disableTimerReward()');
}

